import {
  Collapse,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
} from "@mui/material";
import UsStatesSelector from "components/common/UsStatesSelector";
import * as labels from "config.labels";
import * as staticDataService from "services/staticDataService";
import { useTranslator } from "store/hooks/staticDataHooks";

const NONE_KEY = "__NONE__";

const Deregulated = ({ state, onChange }) => {
  const { isActive, type, jurisdiction, comment } = state ?? {};
  const { data: config, isLoading } = staticDataService.useConfigQuery(
    "regulatory_exemptions"
  );

  const translateLabel = useTranslator("uiLabels");

  return (
    <>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <InputLabel>
          {translateLabel(labels.DEREGULATED_LABEL, {
            default: "Deregulated",
          })}
        </InputLabel>
        <Switch
          checked={isActive ?? false}
          onChange={(e) => {
            onChange &&
              onChange({
                deregulated: {
                  isActive: e.target.checked,
                  type: null,
                  jurisdiction: null,
                  comment: null,
                },
              });
          }}
        />
      </Stack>
      <Collapse in={isActive}>
        <Stack marginTop={1} gap={2}>
          <FormControl variant={"filled"} fullWidth>
            <InputLabel shrink>
              {translateLabel(labels.DEREGULATED_TYPE, {
                default: "Type",
              })}
            </InputLabel>
            <Select
              value={isLoading || !type ? NONE_KEY : type}
              onChange={(e) => {
                onChange &&
                  onChange({
                    deregulated: {
                      isActive,
                      type: e.target.value === NONE_KEY ? null : e.target.value,
                      jurisdiction,
                      comment,
                    },
                  });
              }}
              disabled={isLoading}
            >
              <MenuItem value={NONE_KEY}>&nbsp;</MenuItem>
              {(config?.deregulatedStatusTypes ?? []).map((type) => (
                <MenuItem value={type.key} key={type.key}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <UsStatesSelector
            label={translateLabel(labels.DEREGULATED_JURISDICTION, {
              default: "Jurisdiction",
            })}
            stateId={jurisdiction}
            onChange={(stateId) => {
              onChange &&
                onChange({
                  deregulated: {
                    isActive,
                    type,
                    jurisdiction: stateId,
                    comment,
                  },
                });
            }}
          />
          <TextField
            type={"text"}
            InputLabelProps={{ shrink: true }}
            label={translateLabel(labels.DEREGULATED_COMMENT, {
              default: "Comment",
            })}
            variant={"filled"}
            onChange={(e) => {
              onChange &&
                onChange({
                  deregulated: {
                    isActive,
                    type,
                    jurisdiction,
                    comment: e.target.value === "" ? null : e.target.value,
                  },
                });
            }}
            value={comment || ""}
            fullWidth
            multiline
            rows={3}
          />
        </Stack>
      </Collapse>
    </>
  );
};

export default Deregulated;
